
import React from 'react';
import { R2pGSlider } from './slider';
import styles from './slider-bn_1.css';

export const BnSlider = _ => <R2pGSlider {..._} styles={styles} isBn={true} />
